import {
    ReportTemplateDeleteDto,
    ReportTemplateDto,
    ReportTemplateSaveDto,
    ReportTemplateType,
} from "../models/reporting/reportTemplate";
import { apiCall } from "./apiClient";

export const getReportTemplates = async(
    type: ReportTemplateType,
    signal?: AbortSignal
) => {
    const response = await apiCall<ReportTemplateDto[]>(
        `ReportTemplates/${encodeURIComponent(type)}`,
        "GET",
        null,
        signal
    );
    return response.data;
};

export const saveReportTemplate = async(data: ReportTemplateSaveDto) => {
    const response = await apiCall<ReportTemplateDto>(
        "ReportTemplates",
        "POST",
        data
    );
    return response.data;
};

export const deleteReportTemplate = async(id: string, data: ReportTemplateDeleteDto) => {
    return await apiCall<void>(
        `ReportTemplates/${encodeURIComponent(id)}`,
        "DELETE",
        data
    );
};
